import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import './Container.sass'

class Container extends PureComponent {
  static propTypes = {
    fluid: PropTypes.string
  }

  static defaultProps= {
    fluid: ''
  }

  render() {
    const {fluid, children} = this.props
    return (
      <div className={fluid ? 'container-fluid' : 'container'}>
        {children}
      </div>
    )
  }
}

export default Container



// WEBPACK FOOTER //
// ./components/Container/index.jsx